import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import DeleteProduct from "../../../FormDialog/DeleteProduct";
import AssessmentIcon from "@material-ui/icons/Assessment";
import {
  Container,
  Chip,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  Avatar,
  Grid,
  Paper,
  Modal,
  Typography,
  TextField,
  Button,
  Divider,
} from "@material-ui/core";
import { useUserContext } from "../../../../context/UserContext";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import useStyles from "./styles";
import Pal from "../../../../themes/palette";
import ImgNotAvailable from "../../../../assets/images/imgNotAvailable.jpg";
import ImageCropProfile from "../../../FormDialog/ImageCropProfile";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import RemoveProfilePic from "../../../FormDialog/RemoveProfilePic";

export default function ViewVendors() {
  const classes = useStyles();
  // context
  const { store } = useUserContext();
  const token = store.data.token;

  /////////////////////////Vendor Details Start/////////////////////////////////////////////////////
  ///////////////////////////Vendor Details Start/////////////////////////////////////////////////////
  const [vendorDetails, setVendorDetails] = useState({
    companyName: "",
    email: "",
    businessNumber: "",
    address: "",
    description: "",
    typeOfBusiness: "",
    productCategories: "",
    vendorCategory: "",
    contactPersonName: "",
    contactPersonDesignation: "",
    contactPersonNumber: "",
    logo: "",
    city: "",
    country: "",
  });

  const handleVendorDetails = (input) => (e) => {
    setVendorDetails({ ...vendorDetails, [input]: e.target.value });
  };
  ///////////////////////////Vendor Details End/////////////////////////////////////////////////////
  const [details, setDetails] = useState([]);
  const [listProducts, setListProducts] = useState([]);

  /////////////// Snackbar///////////////////////////////////////////////////////////////////
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  ///////////////Snack Bar End ///////////////////////////////////////////////////////////////////

  const editVendorHandler = (e) => {
    e.preventDefault();

    const {
      companyName,
      email,
      businessNumber,
      address,
      description,
      typeOfBusiness,
      productCategories,
      vendorCategory,
      contactPersonName,
      contactPersonDesignation,
      contactPersonNumber,
      logo,
      city,
      country,
    } = vendorDetails;

    api
      .patch(
        `/admin/vendor/${vendorDetails._id}`,
        {
          companyName,
          email,
          businessNumber,
          address,
          description,
          typeOfBusiness,
          productCategories,
          vendorCategory,
          contactPersonName,
          contactPersonDesignation,
          contactPersonNumber,
          logo,
          city,
          country,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        try {
          const newDetails = details.map((prod) =>
            prod._id === vendorDetails._id ? vendorDetails : prod
          );
          setDetails(newDetails);
          handleClose();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Vendor Info has been Updated!",
            open: true,
          });
        } catch (error) {}
      })
      .catch((error) => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Something is not working properly!",
          type: "error",
          open: true,
        });
      });
  };

  ////////////////image upload settings start//////////////////////////////////
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const onSelectlogo = (image) => {
    setVendorDetails({ ...vendorDetails, logo: image });
  };

  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setVendorDetails({ ...vendorDetails, logo: null });
    setIsProfilePicRemove(false);
  };
  ////////////////image upload settings end //////////////////////////////////

  // image Modal Settings here
  const [modalOpenn, setModelOpenn] = useState(false);
  const handleOpenn = () => {
    setModelOpenn(true);
  };
  const handleClosen = () => {
    setModelOpenn(false);
  };

  ////////////////image upload settings end //////////////////////////////////

  // Edit Product Modal Settings here
  const [modalOpenEditProduct, setModelOpenEditProduct] = useState(false);
  const handleOpenEditProduct = () => {
    setModelOpenEditProduct(true);
  };
  const handleCloseEditProduct = () => {
    setModelOpenEditProduct(false);
  };
  // Delete Product Modal Settings here
  const [modalOpenDeleteProduct, setModelOpenDeleteProduct] = useState(false);
  const handleOpenDeleteProduct = () => {
    setModelOpenEditProduct(true);
  };
  const handleCloseDeleteProduct = () => {
    setModelOpenEditProduct(false);
  };

  // Delete Product Dialog
  const [isDeletingProduct, setIsDeletingProduct] = useState(false);
  const [vendorId, setVendorId] = useState("");
  // show delete Account Dialog
  const handlerAccountDelete = () => {
    setIsDeletingProduct(true);
  };
  // Delete Account Handler
  const confirmedDelete = () => {
    const productId = productDetails._id;

    // api to delete product
    api
      .delete(`/superAdmin/vendor/product/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // Removing deleted Product from details array
        const newDetails = listProducts.filter(
          (prod) => prod._id !== productId
        );

        setListProducts(newDetails);
        setIsDeletingProduct(false);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Product has been deleted!",
          open: true,
        });
        handleCloseEditProduct();
        handleCloseProduct();
        retrivingAllProductsOfVendor(productDetails.vendorId);

        handleOpenProduct();
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went wrong!",
          open: true,
        });
      });
  };

  const editProductHandler = (e) => {
    e.preventDefault();

    var hasError = InputValidation();

    if (hasError === false) {
      api
        .patch(
          `/superAdmin/vendor/product/${productDetails._id}`,
          {
            ...productDetails,
            colors,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          const newDetails = details.map((prod) =>
            prod._id === productDetails._id ? productDetails : prod
          );
          setDetails(newDetails);
          handleClose();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Product has been Updated!",
            open: true,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(() => {
          handleClose();
          setSnackBar({
            ...snackBarstate,
            message: "ERROR: Something is not working properly!",
            type: "error",
            open: true,
          });
        });
    }
  };

  const deleteAllProducts = (e) => {
    e.preventDefault();
    // api to delete product
    api
      .delete(`/superAdmin/vendor/${vendorId}/products`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: All Products have been deleted!",
          open: true,
        });
        handleCloseEditProduct();
        handleCloseProduct();
        retrivingAllProductsOfVendor(vendorId);

        handleOpenProduct();
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went wrong!",
          open: true,
        });
      });
  };

  /////////////////Product images upload option start////////////////////////////////////
  // category list retrive from DB
  const [vendorName, setVendorName] = useState("");
  const [productCategories, setProductCategories] = useState([]);
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [productBrand, setProductBrand] = useState([]);
  const [productDetails, setProductDetails] = useState({
    name: "test",
    description: "test",
    category: "",
    subCategory: "",
    manufactureDate: "11/06/2003",
    purchasePrice: "1000",
    salePrice: "1000",
    state: "New",
    shippingCost: "20",
    images: [""],
    discountPercentage: 10,
    discountPrice: 0,
    stockAvailable: 0,
    dimensions: "",
    isOnSale: false,
    warranty: "",
    weight: "",
  });
  const [colors, setColors] = useState([]);
  const [dimensions, setDimensions] = useState({
    length: "",
    width: "",
    height: "",
    unit: "in",
  });
  const [warranty, setWarranty] = useState("");
  const [warrantySpan, setWarrantySpan] = useState("year");
  const [weight, setWeight] = useState("");
  const [weightUnits, setWeightUnits] = useState("Kg");

  const handlerColor = () => (e) => {
    var newColor = e.target.value;

    const found = colors.some((el) => el === newColor);
    if (!found) {
      setColors([...colors, e.target.value]);
    }
  };

  const handleDeleteColor = (el) => () => {
    setColors((colors) => colors.filter((color, index) => index !== el));
  };

  // updating BankDetails usestate
  const handleProductDetails = (input) => (e) => {
    setProductDetails({ ...productDetails, [input]: e.target.value });
  };

  const HanderdiscountSwitch = (e) => {
    setProductDetails({ ...productDetails, isOnSale: e.target.checked });
  };

  const handlerDiscount = (input) => (e) => {
    const discount = e.target.value;

    var discountPrice =
      productDetails.salePrice - productDetails.salePrice * (discount / 100);

    setProductDetails({
      ...productDetails,
      [input]: e.target.value,
      discountPrice,
    });

    console.log(productDetails);
  };
  const handleWarranty = (e) => {
    setWarranty(e.target.value);
  };
  const handleWarrantySpan = (e) => {
    setWarrantySpan(e.target.value);
  };
  const handleWeight = (e) => {
    setWeight(e.target.value);
  };
  const handleWeightUnit = (e) => {
    setWeightUnits(e.target.value);
  };

  const handlerDimension = (input) => (e) => {
    setDimensions({ ...dimensions, [input]: e.target.value });
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const fileHandler = async (event) => {
    let prevImages = productDetails.images;
    let files = event.target.files;
    let temp = [];

    for (let i = 0; i < files.length; i++) {
      var file64 = await toBase64(files[i]);
      temp.push(file64);
    }

    if (prevImages.length > 0) {
      setProductDetails({
        ...productDetails,
        images: [...prevImages, ...temp],
      });
    } else {
      setProductDetails({
        ...productDetails,
        images: temp,
      });
    }
  };

  const handlerDeletePImage = (index) => {
    const pImages = productDetails.images.filter(
      (el, eindex) => eindex !== index
    );

    setProductDetails({
      ...productDetails,
      images: pImages,
    });
  };

  const [IFerrors, setIFerrors] = useState({
    nameError: "",
    descriptionError: "",
    categoryError: "",
    subCategoryError: "",
    purchasePriceError: "",
    salePriceError: "",
    stateError: "",
    shippingCostError: "",
    stockError: "",
    warrantyError: "",
  });

  const InputValidation = () => {
    const errors = {};
    var hasError = false;

    // name
    var nameFormat = /^[0-9A-Za-z\s_+()'#@&-]+$/;
    if (productDetails.name.match(nameFormat)) {
      errors.nameError = "";
    } else {
      hasError = true;
      errors.nameError =
        "Invalid Input. Name cannot contains several Special Characters!";
    }

    // description
    var descFormat = /^[A-Za-z0-9.,'!()#&+-\s]+$/;
    if (productDetails.description.match(descFormat)) {
      errors.descriptionError = "";
    } else {
      hasError = true;
      errors.descriptionError =
        "Description contains several characters that aren't allowed!";
    }

    // Product category
    if (productDetails.category.length === 0) {
      hasError = true;
      errors.categoryError = "Please Choose a Category for Product!";
    } else {
      errors.categoryError = "";
    }

    // subcategory
    if (productDetails.subCategory.length === 0) {
      hasError = true;
      errors.subCategoryError = "Please Choose Sub-Category for Product!";
    } else {
      errors.subCategoryError = "";
    }

    // state
    if (productDetails.state.length === 0) {
      hasError = true;
      errors.stateError = "Please Choose the Product State!";
    } else {
      errors.stateError = "";
    }

    // stock
    var stockFormat = /^[1-9]\d*$/;
    if (productDetails.stockAvailable.toString().match(stockFormat)) {
      errors.stockError = "";
    } else {
      hasError = true;
      errors.stockError = "Entered stock amount is invalid.";
    }

    // Shipping cost
    var shippingFormat = /^[1-9]\d*$/;
    if (productDetails.shippingCost.toString().match(shippingFormat)) {
      errors.shippingCostError = "";
    } else {
      hasError = true;
      errors.shippingCostError = "Entered Shipping Amount is invalid.";
    }

    // price
    var PriceFormat = /^\d+(.\d{1,2})?$/;
    if (productDetails.purchasePrice.toString().match(PriceFormat)) {
      errors.purchasePriceError = "";
    } else {
      hasError = true;
      errors.purchasePriceError = "Entered Amount is invalid.";
    }

    if (productDetails.salePrice.toString().match(PriceFormat)) {
      errors.salePriceError = "";
    } else {
      hasError = true;
      errors.salePriceError = "Entered Amount is invalid.";
    }

    // warranty
    var warrantyFormat = /[0-9]+/;
    if (productDetails.warranty.match(warrantyFormat)) {
      errors.warrantyError = "";
    } else {
      hasError = true;
      errors.warrantyError = "Entered Warranty is invalid.";
    }

    setIFerrors({ ...IFerrors, ...errors });
    return hasError;
  };

  const resetInputFiels = () => {
    setWeight("");
    setWarranty("");
    setProductDetails({
      name: "",
      description: "",
      category: "",
      subCategory: "",
      manufactureDate: "11/06/2003",
      purchasePrice: "",
      salePrice: "",
      state: "",
      shippingCost: "",
      images: [],
      isOnSale: false,
      discountPercentage: "",
      discountPrice: "",
      stockAvailable: "",
      dimensions: "",
    });
    setDimensions({
      length: "",
      width: "",
      height: "",
      unit: "in",
    });
    setColors([]);
  };

  /////////////////Product images upload option End////////////////////////////////////

  // Edit Product Modal Settings here
  const [modalOpenProduct, setModelOpenProduct] = useState(false);
  const handleOpenProduct = () => {
    setModelOpenProduct(true);
  };
  const handleCloseProduct = () => {
    setModelOpenProduct(false);
  };

  // Edit vendor Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };
  const getAllVendors = async () => {
    await api
      .get("/admin/vendors", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("details are ", res.data.data);
        setDetails(res.data.data.vendors);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const retrivingAllProductsOfVendor = async (id) => {
    await api
      .get(`/superAdmin/vendor/${id}/products`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("res is ", res.data.data.products);
        setListProducts(res.data.data.products);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };
  /////////////////Ending /////////////////////////////////////////////////////////////////////

  const columnsProduct = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Image",
      field: "images",
      render: ({ images }) => (
        <img
          src={images.length > 0 ? images[0] : ImgNotAvailable}
          alt="ProductImage"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
      hidden: false,
      export: false,
    },
    { title: "Name", field: "name", hidden: false, export: true },
    {
      title: "description",
      field: "description",
      hidden: true,
      export: true,
    },
    {
      title: "Vendor Name",
      field: "vendorCompanyName",
      hidden: false,
      export: true,
    },
    { title: "Category", field: "category", hidden: false, export: true },
    {
      title: "purchasePrice",
      field: "purchasePrice",
      hidden: true,
      export: true,
    },
    {
      title: "SalePrice",
      field: "salePrice",
      render: ({ salePrice }) => <div>{"Rs." + salePrice}</div>,
      hidden: false,
      export: true,
    },
    {
      title: "State",
      field: "state",
      hidden: false,
      export: true,
    },
    {
      title: "StockAvailable",
      field: "stockAvailable",
      hidden: false,
      export: true,
    },
    {
      title: "discountPercentage",
      field: "discountPercentage",
      hidden: true,
      export: true,
    },
    { title: "Warranty", field: "warranty", hidden: false, export: true },
    {
      title: "Colors",
      field: "colors",
      render: ({ colors }) => <div>{colors[0]}</div>,
      hidden: true,
      export: false,
    },
    {
      title: "isVisibilityEnabled",
      field: "isVisibilityEnabled",
      render: ({ isVisibilityEnabled }) => <div>{isVisibilityEnabled}</div>,
      hidden: true,
      export: true,
    },
    {
      title: "manufactureDate",
      field: "manufactureDate",
      hidden: true,
      export: true,
    },
    {
      title: "shippingCost",
      field: "shippingCost",
      hidden: true,
      export: true,
    },
    {
      title: "dimensions",
      field: "dimensions",
      hidden: true,
      export: true,
    },
    {
      title: "weight",
      field: "weight",
      hidden: true,
      export: true,
    },
  ];

  const columnsVendor = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
      cellstyle: { whiteSpace: "nowrap" },
    },
    {
      title: "Image",
      field: "logo",
      sorting: false,
      render: ({ logo }) => (
        <img
          src={logo != null ? logo : ImgNotAvailable}
          alt="ProductImage"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
      hidden: false,
      export: false,
    },
    {
      title: "Name",
      field: "companyName",
      width: 150,
    },
    {
      title: "Email",
      field: "email",
      width: 150,
    },
    { title: "Business Type", field: "typeOfBusiness", width: "0%" },

    {
      title: "Contact",
      field: "businessNumber",
      width: 150,
    },
    { title: "City", field: "city", width: "0%" },
    {
      title: "Status",
      field: "status",
      align: "center",
      render: ({ status }) => (
        <div
          style={{
            height: 30,
            width: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: checkStatusColor(status),
            color: "white",
            borderRadius: 4,
          }}
        >
          {status}
        </div>
      ),
    },
    {
      field: "Actions",
      title: "Actions",
      align: "center",
      render: (rowData) => (
        <div>
          <Select
            id="status"
            style={{ marginTop: 8 }}
            defaultValue={"DEFAULT"}
            onChange={handerChangeStatus(rowData._id)}
          >
            <MenuItem value="DEFAULT" disabled>
              Status
            </MenuItem>
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Blocked">Blocked</MenuItem>
          </Select>
        </div>
      ),
      export: false,
    },
  ];
  // // category list retrive from DB
  const [vendorCategories, setVendorCategories] = useState([]);
  const getVendorCategory = async () => {
    // Parent Category
    api
      .get("/admin/vendorCategories", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data);
        const categoryList = res.data.data.categories;
        setVendorCategories(categoryList);
      })
      .catch((error) => console.log("Error: " + error));
  };

  const getAllCategory = async () => {
    // Parent Category
    api
      .get("/superAdmin/product/categories/view", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const categoryList = res.data.data.categories;
        // console.log("categories are ", categoryList);
        setProductCategories(categoryList);
      })
      .catch((error) => console.log("Error: " + error));
  };

  const getSubCategory = async () => {
    console.log(productDetails.category);
    if (productDetails.category !== "") {
      await api
        .get(`/superAdmin/subCategories/${productDetails.category}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          let categoryList = res.data.data.categories;
          let subCat = categoryList.map((el) => el.subCategory);
          let brands = categoryList.map((el) => el.brands);
          setProductSubCategories(subCat[0]);
          setProductBrand(brands[0]);
        })
        .catch((error) => console.log("Error: " + error));
    }
  };

  const checkStatusColor = (checkStatusColor) => {
    let color = "";
    switch (checkStatusColor) {
      case "Pending":
        color = "#ffb302";
        break;
      case "Active":
        color = "#5AA700";
        break;
      case "Blocked":
        color = "#ff3838";
        break;
      default:
        color = "rgba(230, 126, 34, 0.7)";
    }

    return color;
  };

  const handerChangeStatus = (id) => async (e) => {
    let newStatus = e.target.value;
    const newStoresList = details.map((el) =>
      el._id === id ? { ...el, status: newStatus } : el
    );

    console.log(newStoresList);

    await api
      .patch(
        `/admin/vendor/${id}`,
        { status: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Status has been Changed!",
          open: true,
        });
        setDetails(newStoresList);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went Wrong!",
          open: true,
        });
      });
  };

  useEffect(() => {
    // fetching List of vendors from API
    getAllVendors();
    getVendorCategory();
    getAllCategory();
  }, []);

  useEffect(() => {
    getSubCategory();
    // eslint-disable-next-line
  }, [productDetails.category]);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <MaterialTable
          title="All Vendors of Digi-Mart"
          data={details}
          columns={columnsVendor}
          actions={[
            (rowData) => ({
              icon: () => <VisibilityIcon />,
              tooltip: "View Products Of Vendor",
              onClick: (event, rowData) => {
                setVendorId(rowData._id);
                retrivingAllProductsOfVendor(rowData._id);
                handleOpenProduct();
                setVendorName(rowData.companyName);
              },
            }),
            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit",
              onClick: (event, rowData) => {
                setVendorDetails(rowData);
                handleOpen();
              },
            }),
            (rowData) => ({
              icon: () => <AssessmentIcon />,
              tooltip: "Statistics",
              onClick: (event, rowData) => {
                setVendorDetails(rowData);
                handleOpen();
              },
            }),
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: Pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },
            exportButton: true,
            tableLayout: "auto",
          }}
        />
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>
      {/* //////////////////////////////////////////////////Edit Vendor///////////////////////////////////////// */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          overflow: "scroll",
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: 340,
          width: 700,
          height: "100%",
        }}
      >
        <Grid container className={classes.root}>
          <Grid item xs={12} sm={12} md={12} component={Paper}>
            <div className={classes.paper}>
              <Avatar className={classes.avatar}>
                <LibraryAddIcon />
              </Avatar>
              <Typography variant="h5">Edit Vendor Details</Typography>
              <form className={classes.form}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      required
                      fullWidth
                      label="Company Name"
                      name="companyName"
                      value={vendorDetails.companyName}
                      onChange={handleVendorDetails("companyName")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      required
                      fullWidth
                      label="Email"
                      name="email"
                      value={vendorDetails.email}
                      onChange={handleVendorDetails("companyName")}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      multiline
                      rows={3}
                      name="description"
                      label="Description"
                      value={vendorDetails.description}
                      onChange={handleVendorDetails("description")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      multiline
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Address"
                      name="address"
                      rows={3}
                      value={vendorDetails.address}
                      onChange={handleVendorDetails("address")}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Business Number"
                      name="businessNumber"
                      value={vendorDetails.businessNumber}
                      onChange={handleVendorDetails("businessNumber")}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Select
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Product Category"
                      style={{ marginTop: 8 }}
                      defaultValue={"DEFAULT"}
                      name="vendorCategory"
                    >
                      <MenuItem value="DEFAULT" disabled>
                        Choose a Vendor Category
                      </MenuItem>
                      {vendorCategories.map((el, index) => (
                        <MenuItem value={el.name} key={index}>
                          {el.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Type Of Bunsiness"
                      name="typeOfBusiness"
                      value={vendorDetails.typeOfBusiness}
                      onChange={handleVendorDetails("typeOfBusiness")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Select
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Product Category"
                      style={{ marginTop: 8 }}
                      defaultValue={"DEFAULT"}
                      name="productCategories"
                    >
                      <MenuItem value="DEFAULT" disabled>
                        Choose a Product Category
                      </MenuItem>
                      {vendorCategories.map((el, index) => (
                        <MenuItem value={el.name} key={index}>
                          {el.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Country"
                      name="country"
                      value={vendorDetails.country}
                      onChange={handleVendorDetails("country")}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="City"
                      name="city"
                      value={vendorDetails.city}
                      onChange={handleVendorDetails("city")}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Typography variant="h4" gutterBottom>
                      Representative Details
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      required
                      fullWidth
                      label="Representative Name"
                      name="contactPersonName"
                      value={vendorDetails.contactPersonName}
                      onChange={handleVendorDetails("contactPersonName")}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      required
                      fullWidth
                      label="Representative Number"
                      name="contactPersonNumber"
                      value={vendorDetails.contactPersonNumber}
                      onChange={handleVendorDetails("contactPersonNumber")}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      name="contactPersonDesignation"
                      label="Representative Designation"
                      value={vendorDetails.contactPersonDesignation}
                      onChange={handleVendorDetails("contactPersonDesignation")}
                    />
                  </Grid>
                </Grid>
                {/*///////////////////////// image upload option /////////////////////////////*/}

                {/*///////////////////////// image upload option /////////////////////////////*/}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Avatar
                    alt="profile photo"
                    src={vendorDetails.logo}
                    className={classes.avatarInProfileSetting}
                  >
                    {"Pic here"}
                  </Avatar>
                  <div style={{ marginTop: 30 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleOpenn}
                    >
                      <AddAPhotoIcon
                        style={{
                          marginRight: 5,
                          fontSize: 22,
                          marginBottom: 5,
                        }}
                      />
                      Upload
                    </Button>
                    <Button
                      onClick={handlerRemoveProfilePic}
                      style={{
                        backgroundColor: "#DC143C",
                        color: "white",
                        marginLeft: 7,
                        height: 40,
                      }}
                      variant="contained"
                    >
                      Remove Image
                    </Button>
                  </div>
                </div>
                {/* SAVE CHANGES BUTTON */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={editVendorHandler}
                  >
                    Save Changes
                  </Button>
                  <RemoveProfilePic
                    RemoveProfilePic={isProfilePicRemove}
                    setRemoveProfilePic={setIsProfilePicRemove}
                    confirmedRemoveProfilePic={confirmedRemoveProfilePic}
                  />
                </Grid>

                <Snackbar
                  open={open}
                  anchorOrigin={{ vertical, horizontal }}
                  autoHideDuration={3000}
                  onClose={handleCloseSnackBar}
                  key={vertical + horizontal}
                >
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleCloseSnackBar}
                    severity={snackBarstate.type}
                  >
                    {snackBarstate.message}
                  </MuiAlert>
                </Snackbar>
              </form>
            </div>
          </Grid>
        </Grid>
      </Modal>
      {/* ////////////////////////////////////View Products Modal//////////////////////////////////// */}
      <Modal
        open={modalOpenProduct}
        onClose={handleCloseProduct}
        onBackdropClick={handleCloseProduct}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          component={Paper}
          style={{
            marginBottom: 20,
            padding: "20px",
            maxWidth: "80vw",
            maxHeight: "100vh",
            overflow: "auto",
            scrollbarWidth: "2px",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">All Products Of {vendorName}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} component={Paper}>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} align="right">
                  <Button
                    style={{
                      backgroundColor: "#DC143C",
                      color: "white",
                      marginLeft: 7,
                      height: 40,
                    }}
                    size="large"
                    type="submit"
                    variant="contained"
                    className={classes.submit}
                    onClick={deleteAllProducts}
                  >
                    Delete All Products
                  </Button>
                </Grid>
              </Grid>
              <MaterialTable
                title="Products Of Vendor"
                data={listProducts}
                columns={columnsProduct}
                actions={[
                  (rowData) => ({
                    icon: () => <VisibilityIcon />,
                    tooltip: "View Products",
                    onClick: (event, rowData) => {
                      // handleOpenProduct();
                    },
                  }),
                  (rowData) => ({
                    icon: () => <EditIcon />,
                    tooltip: "Edit",
                    onClick: (event, rowData) => {
                      setProductDetails(rowData);
                      handleOpenEditProduct();
                    },
                  }),
                  (rowData) => ({
                    icon: () => <DeleteIcon />,
                    tooltip: "Delete",
                    onClick: (event, rowData) => {
                      setProductDetails(rowData);
                      handlerAccountDelete();
                    },
                  }),
                ]}
                options={{
                  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: Pal.palette.primary.main,
                    color: "#fff",
                    whiteSpace: "nowrap",
                  },
                  exportButton: true,
                  tableLayout: "auto",
                  // paging: false,
                }}
              />

              <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
            </Grid>
          </Grid>
        </Container>
      </Modal>

      {/* Edit Product Modal */}
      <Modal
        open={modalOpenEditProduct}
        onClose={handleCloseEditProduct}
        onBackdropClick={handleCloseEditProduct}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          component={Paper}
          style={{
            padding: "20px",
            maxWidth: "50vw",
            maxHeight: "80vh",
            overflow: "auto",
            scrollbarWidth: "2px",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Product</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    margin="dense"
                    variant="outlined"
                    required
                    fullWidth
                    label="Name"
                    value={productDetails.name}
                    onChange={handleProductDetails("name")}
                    helperText={IFerrors.nameError}
                    error={IFerrors.nameError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    multiline
                    rows={4}
                    label="Description"
                    value={productDetails.description}
                    onChange={handleProductDetails("description")}
                    helperText={IFerrors.descriptionError}
                    error={IFerrors.descriptionError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Category"
                    style={{ marginTop: 8 }}
                    value={productDetails.category}
                    defaultValue={"DEFAULT"}
                    onChange={handleProductDetails("category")}
                    error={IFerrors.categoryError.length > 0 ? true : false}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose a Product Category
                    </MenuItem>
                    {productCategories.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Sub Category"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={productDetails.subCategory}
                    onChange={handleProductDetails("subCategory")}
                    error={IFerrors.subCategoryError.length > 0 ? true : false}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose sub-category
                    </MenuItem>
                    {productSubCategories.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    placeholder="dd/MM/YYYY"
                    label="Manufacture Date"
                    name="manufactureDate"
                    value={productDetails.manufactureDate}
                    onChange={handleProductDetails("manufactureDate")}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Category"
                    name="category"
                    style={{ marginTop: 8 }}
                    value={"DEFAULT"}
                    defaultValue={"DEFAULT"}
                    onChange={handlerColor("colors")}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Select Product Color
                    </MenuItem>
                    <MenuItem value="Red">Red</MenuItem>
                    <MenuItem value="Green">Green</MenuItem>
                    <MenuItem value="Black">Black</MenuItem>
                    <MenuItem value="Purple">Purple</MenuItem>
                  </Select>
                </Grid>

                {colors.length > 0 ? (
                  <Grid item xs={12}>
                    {colors.map((el, index) => (
                      <Chip
                        label={el}
                        key={index}
                        onDelete={handleDeleteColor(index)}
                        style={{
                          margin: "2px 4px",
                        }}
                      />
                    ))}
                  </Grid>
                ) : (
                  ""
                )}

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="stock"
                    label="Stock / Quantity"
                    value={productDetails.stockAvailable}
                    onChange={handleProductDetails("stockAvailable")}
                    helperText={IFerrors.stockError}
                    error={IFerrors.stockError.length > 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="warranty"
                    label="Warranty"
                    value={productDetails.warranty}
                    onChange={handleProductDetails("warranty")}
                    helperText={IFerrors.warrantyError}
                    error={IFerrors.warrantyError.length > 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Purchase Price"
                    value={productDetails.purchasePrice}
                    onChange={handleProductDetails("purchasePrice")}
                    helperText={IFerrors.purchasePriceError}
                    error={
                      IFerrors.purchasePriceError.length > 0 ? true : false
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Sale Price (Rs)"
                    name="salePrice"
                    value={productDetails.salePrice}
                    onChange={handleProductDetails("salePrice")}
                    helperText={IFerrors.salePriceError}
                    error={IFerrors.salePriceError.length > 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Weight"
                    id="weight"
                    name="weight"
                    value={productDetails.weight}
                    onChange={handleProductDetails("weight")}
                    helperText={IFerrors.weightError}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Product State"
                    name="state"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={productDetails.state}
                    onChange={handleProductDetails("state")}
                  >
                    <MenuItem value="DEFAULT">
                      Select the Product State
                    </MenuItem>
                    <MenuItem value="New">New</MenuItem>
                    <MenuItem value="Used">Used</MenuItem>
                    <MenuItem value="Refurbished">Refurbished</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Shipping Cost"
                    name="shippingCost"
                    value={productDetails.shippingCost}
                    onChange={handleProductDetails("shippingCost")}
                    helperText={IFerrors.shippingCostError}
                    error={IFerrors.shippingCostError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Dimensions"
                    placeholder="100in 100in 100in"
                    value={productDetails.dimensions}
                    onChange={handleProductDetails("dimensions")}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 20,
                    marginBottom: 5,
                    padding: 20,
                    height: 120,
                    border: "1px solid #c4c4c4",
                    borderRadius: 6,
                  }}
                >
                  <Grid container justify="center" spacing={2}>
                    {productDetails.images.length > 0 ? (
                      productDetails.images.map((img, index) => (
                        <Grid item key={index} align="center">
                          <img
                            src={img}
                            alt="product-images"
                            width="60px"
                            height="60px"
                            style={{
                              border: "3px solid #e1e1e1",
                              padding: "2px",
                            }}
                          />
                          <div>
                            <HighlightOffRoundedIcon
                              onClick={() => handlerDeletePImage(index)}
                              style={{
                                color: "grey",
                              }}
                            />
                          </div>
                        </Grid>
                      ))
                    ) : (
                      <Typography>Upload Product Images</Typography>
                    )}
                  </Grid>
                </Grid>
                <Grid item style={{ marginBottom: 10, marginLeft: 10 }}>
                  <div>
                    <label htmlFor="contained-button-file">
                      <Button
                        size="small"
                        startIcon={<AddPhotoAlternateIcon />}
                        variant="outlined"
                        color="primary"
                        component="span"
                      >
                        Upload Images
                      </Button>
                    </label>
                    <input
                      id="contained-button-file"
                      type="file"
                      multiple
                      accept="image/png, image/jpeg"
                      onChange={fileHandler}
                      hidden
                    />
                  </div>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ marginLeft: 5, marginRight: 5 }}
                >
                  <Grid item xs={4}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        border: "1px solid #c4c4c4",
                        borderRadius: 4,
                        marginTop: 8,
                      }}
                    >
                      <FormControlLabel
                        margin="normal"
                        control={
                          <Switch
                            color="primary"
                            checked={productDetails.isOnSale}
                            onChange={HanderdiscountSwitch}
                          />
                        }
                        label="On Sale"
                        labelPlacement="start"
                      />
                    </div>
                  </Grid>

                  {productDetails.isOnSale ? (
                    <Grid item xs={8}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        required
                        fullWidth
                        label="Discount(%)"
                        id="discount"
                        name="discount"
                        value={productDetails.discountPercentage}
                        onChange={handlerDiscount("discountPercentage")}
                        helperText={IFerrors.discountPercentageError}
                        error={
                          IFerrors.discountPercentageError.length > 0
                            ? true
                            : false
                        }
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>

                {/* SAVE CHANGES BUTTON */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={editProductHandler}
                  >
                    Save Changes
                  </Button>
                </Grid>
              </Grid>

              <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
            </form>
          </Grid>
        </Container>
      </Modal>

      <Modal
        open={modalOpenn}
        onClose={handleClosen}
        onBackdropClick={handleClosen}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClosen}
          />
        </div>
      </Modal>

      {/* Delete Confirmation Dialog */}
      <DeleteProduct
        DeletingProduct={isDeletingProduct}
        setDeletingProduct={setIsDeletingProduct}
        confirmedDelete={confirmedDelete}
      />
    </Grid>
  );
}
